import React from 'react'
import { useAccountMode } from '../../../../hooks/useAccountMode'

export default function TaskItemPremiumPrize() {
  const { mode: accountMode } = useAccountMode()

  return {
    standard: null,
  }[accountMode]
}
